export default __webpack_public_path__ + "static/media/stairslogo.a1bcdf7d.png";